"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preview_button_html_1 = __importDefault(require("./preview-button.html"));
(function (module) {
    'use strict';
    function PreviewButtonController(navigationService, metricsService) {
        var $ctrl = this;
        angular.extend($ctrl, {
            previewReports: function () {
                navigationService.loadPreview(metricsService.CALL_SOURCE.BUTTON);
            }
        });
    }
    PreviewButtonController.$inject = [
        'pr.navigationService',
        'prMetricsService'
    ];
    module.component('prPreviewButton', {
        templateUrl: preview_button_html_1.default,
        controller: PreviewButtonController
    });
})(angular.module('qualtrics.pr'));
